/*
 * @Descripttion: 交易学院 API 接口
 * @version: 1.0
 * @Author: Auto Generated
 * @Date: 2024
 */
import axios from "axios";
console.log(
  "process.env.NODE_ENV",
  process.env.NODE_ENV,
  process.env.NODE_ENV === "development"
    ? "/academy"
    : "https://academy.ebccfd.com"
);

// 创建交易学院专用的 axios 实例
// 开发环境使用代理路径，生产环境使用完整URL
const academyInstance = axios.create({
  baseURL: "https://academy.ebccfd.com", //process.env.NODE_ENV === 'development' ? '/academy' : 'https://academy.ebccfd.com',
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

// 请求拦截器
academyInstance.interceptors.request.use(
  function (config) {
    // 请求发送前的处理
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
academyInstance.interceptors.response.use(
  function (response) {
    // 统一处理响应数据
    return response;
  },
  function (error) {
    // 统一处理错误
    return Promise.reject(error);
  }
);

/**
 * 1. 学院首页 - 获取交易学院首页的核心板块数据（不含直播课程）
 * @returns {Promise}
 */
export function getAcademyHome() {
  return academyInstance.get("/api/academy-home");
}

/**
 * 2. 文章列表 - 通用文章列表接口，用于各级分类页
 * @param {String} routeName - 分类路由标识 (如: ebc-official, forex-basic, recent 等)
 * @param {Number} page - 页码，默认为 1
 * @returns {Promise}
 */
export function getAcademyList(routeName, page = 1) {
  return academyInstance.get(`/api/academy-list/${routeName}`, {
    params: {
      page,
    },
  });
}

/**
 * 2. 文文章详情
 * @param {String} routeName - 分类路由标识 (如: ebc-official, forex-basic, recent 等)
 * @param {Number} page - 页码，默认为 1
 * @returns {Promise}
 */
export function getAcademyDetail(id) {
  return academyInstance.get(`/api/academy-detail?id=${id}`);
}

/**
 * 3. 软件教程 - MT4 教程
 * @returns {Promise}
 */
export function getMT4Tutorial() {
  return academyInstance.get("/api/academy-software/mt4");
}

/**
 * 3. 软件教程 - MT5 教程
 * @returns {Promise}
 */
export function getMT5Tutorial() {
  return academyInstance.get("/api/academy-software/mt5");
}

/**
 * 3. 软件教程 - Trading Central 教程
 * @returns {Promise}
 */
export function getTradingCentralTutorial() {
  return academyInstance.get("/api/academy-software/trading-central");
}

/**
 * 3. 软件教程 - Trading View 教程
 * @returns {Promise}
 */
export function getTradingViewTutorial() {
  return academyInstance.get("/api/academy-software/trading-view");
}

/**
 * 3. 软件教程 - 订单流 Order Flow 教程
 * @returns {Promise}
 */
export function getOrderFlowTutorial() {
  return academyInstance.get("/api/academy-software/order-flow");
}

/**
 * 3. 软件教程 - EA工具库
 * @returns {Promise}
 */
export function getEaTurboTutorial() {
  return academyInstance.get("https://academy.ebccfd.com/api/academy-software/ea-turbo");
}



/**
 * 4. 交易词典 - 获取按首字母 A-Z 分组的金融术语
 * @returns {Promise}
 */
export function getAcademyDictionary() {
  return academyInstance.get("/api/academy-dictionary");
}

/**
 * 5. 交易大师 - 获取交易大师列表
 * @returns {Promise}
 */
export function getAcademyExpert() {
  return academyInstance.get("/api/academy-expert");
}

/**
 * 5. 精选书籍 - 获取推荐书籍列表
 * @returns {Promise}
 */
export function getAcademyBook() {
  return academyInstance.get("/api/academy-book");
}

/**
 * 5. 市场公告 - 获取市场快讯/公告列表
 * @returns {Promise}
 */
export function getAcademyBulletin() {
  return academyInstance.get("/api/academy-bulletin");
}

/**
 * 6.1 搜索建议 - 用于搜索框输入时的下拉联想
 * @param {String} keyword - 用户输入的关键词
 * @returns {Promise}
 */
export function getSearchSuggestions(query, typeValue) {
  return academyInstance.get("/api/search/suggestions", {
    params: {
      query,
      category_id: typeValue,
      lang: "zh-cn",
    },
  });
}

/**
 * 6.2 搜索结果 - 用于搜索结果列表页展示
 * @param {String} keyword - 搜索关键词
 * @param {Number} page - 页码，默认为 1
 * @returns {Promise}
 */
export function getSearchResults(keyword, typeValue, page = 1) {
  return academyInstance.get("/api/search/results", {
    params: {
      query: keyword,
      category_id: typeValue,
      page: page,
      pageSize: 16,
      lang: "zh-cn",
    },
  });
}

// 默认导出所有接口
export default {
  getAcademyHome,
  getAcademyList,
  getMT4Tutorial,
  getMT5Tutorial,
  getTradingCentralTutorial,
  getTradingViewTutorial,
  getOrderFlowTutorial,
  getAcademyDictionary,
  getAcademyExpert,
  getAcademyBook,
  getAcademyBulletin,
  getSearchSuggestions,
  getSearchResults,
};
